<div class="grid-container">
  <div class="header">
    <nav class="actions-container">
      <frodo-language-selector></frodo-language-selector>
    </nav>
    <div class="title-container">
      <p class="title">{{ 'common.welcome' | translate }}</p>
    </div>
  </div>

  <div class="cards-container">
    <p class="text" *ngIf="vision10kFlow; else prescriptiveMessage" data-testid="launch-screen-msg">
      {{ 'common.frictionlessMessage' | translate }}
    </p>
    <ng-template #prescriptiveMessage>
      <p class="text">{{ 'common.prescriptiveMessage' | translate }}</p>
    </ng-template>
    <button
      *ngIf="!vision10kFlow"
      [disabled]="!availableSpaces && !enableOverflowArea"
      class="begin-button"
      [ngClass]="
        availableSpaces || enableOverflowArea ? 'begin-button__enabled' : 'begin-button__disabled'
      "
      (click)="navigate()"
      data-testid="begin-btn"
    >
      {{ 'common.begin' | translate }}
    </button>
  </div>
  <div class="welcome-screen-nav">
    <span class="welcome-screen-nav__powered-by"> {{ 'common.poweredBy' | translate }} </span>
    <frodo-logo [src]="configScreen.logo" alt="logo"></frodo-logo>
  </div>
</div>
